import React, { memo } from 'react';

import { AccordionButton, AccordionButtonProps, AccordionIcon } from '@chakra-ui/accordion';

interface IProps extends AccordionButtonProps {
  iconOnLeft?: boolean;
}

const AccordionHeaderComponent: React.FC<IProps> = ({ children, iconOnLeft, ...props }) => {
  return (
    <AccordionButton {...props} padding="0" _focus={{ boxShadow: 'none' }} color="brand.900">
      {iconOnLeft && <AccordionIcon color="brand.900" mr=".5rem" />}

      {children}

      {!iconOnLeft && <AccordionIcon ml="auto" color="brand.900" />}
    </AccordionButton>
  );
};

export const AccordionHeader = memo(AccordionHeaderComponent);
